export default class Routing {
  static routes = {};
  static params = {};
  static routeObject = null;
  static paths = [];

  // generic functionality
  static getAllRoutes = () => Object.keys(Routing.routes);
  static getRoutesByAuthAccess = access => Object.keys(Routing.routes).filter((key) => (Routing.routes[key].authAccess || 'protected') === access);
  static getPublicRoutes = () => Routing.getRoutesByAuthAccess('public');
  static getSharedRoutes = () => Routing.getRoutesByAuthAccess('shared');
  static getProtectedRoutes = () => Routing.getRoutesByAuthAccess('protected');
  static getPathNameSplit = () => window.location.pathname.split('/');
  static getPathNamePartsFiltered = () => Routing.getPathNameSplit().filter(part => part !== "");
  static getLanguageCodeFromPathName = () => Routing.getPathNamePartsFiltered()[0];
  static getRouteFromPathName = () => Routing.getPathNamePartsFiltered()[1];
  static getIdFromPathName = () => Routing.getPathNamePartsFiltered()[2];
  static getSubPageFromPathName = () => Routing.getPathNamePartsFiltered()[3];

  static matchRoute(routesObj, path) {
    for (const pattern in routesObj) {
      const regexPattern = "^" + pattern
        .replace(/:[^\/]+/g, "([^/]+)")  // convert :param to regex group
        .replace(/\//g, "\\/") + "$";   // escape slashes

      const regex = new RegExp(regexPattern);
      const match = path.match(regex);
      if (match) {
        return [pattern, routesObj[pattern]];
      }
    }
    return null;
  }

  /* unused. do i need it?
  static extractParams(pattern, match) {
    const keys = [...pattern.matchAll(/:([^\/]+)/g)].map(m => m[1]);
    const values = match.slice(1);
    return Object.fromEntries(keys.map((k, i) => [k, values[i]]));
  }
    */
  
  static getPathWithoutLanguageCode = () => {
    let parts = Routing.getPathNamePartsFiltered();
    if (parts.length === 1) {
      return "/"; // only one result means it's just the lang code
    }

    return "/" + parts.slice(1).join('/');
  }

  static getRouteObject() {
    let pathName = Routing.getPathWithoutLanguageCode();
    let result = Routing.matchRoute(Routing.routes, pathName); // getting route object

    // parse params in route
    const regex = new RegExp(result[0]);
    const match = pathName.match(regex);
    if (match) {
      Routing.params.id = match[1];
    }

    Routing.routeObject = result[1];
    return result[1] || Error404;
  }

  static isLangCodePresent() {
    let parts = Routing.getPathNamePartsFiltered();
    if (!parts[0]) return false;
    if (parts[0].length !== 2) return false;
    return true;
  }
}

globalThis.Routing = Routing;
